<template>
  <div>
    <rk-select-root v-model="value" :multiple="multiple" :required="required">
      <app-form-field
        v-bind="fieldBinding"
        ref="wrapper"
        label-element-as="div"
      >
        <template #default="{ inputClass }">
          <rk-select-trigger class="flex" :class="inputClass">
            <rk-select-value
              class="flex items-center"
              :placeholder="placeholder"
            />
          </rk-select-trigger>

          <rk-select-portal>
            <rk-select-content
              :align-offset="prependIcon ? -24 : 0"
              class="bg-white shadow min-w-(--wrapperWidth) p-2 rounded"
              position="popper"
              side="bottom"
              :side-offset="5"
              :style="{ '--wrapperWidth': `${wrapper?.$el?.clientWidth}px` }"
            >
              <rk-select-viewport>
                <div v-if="$slots.prepend" class="p-2">
                  <slot name="prepend" />
                </div>

                <rk-select-item
                  v-for="option in items as Record<string, string>[]"
                  :key="option[itemValue]"
                  class="mb-1 last:mb-0 p-2 cursor-pointer text-sm data-[highlighted]:outline-none data-[highlighted]:bg-primary-50 rounded data-[state='checked']:bg-primary-100 data-[state='checked']:text-primary-950 data-[highlighted]:text-primary-950"
                  :data-value="option[itemValue]"
                  :value="option[itemValue]!"
                >
                  <rk-select-item-text>
                    <slot name="item" v-bind="{ item: option }">
                      {{ option[itemTitle] }}
                    </slot>
                  </rk-select-item-text>
                </rk-select-item>
              </rk-select-viewport>
            </rk-select-content>
          </rk-select-portal>
        </template>
      </app-form-field>
    </rk-select-root>
  </div>
</template>

<script lang="ts" setup>
import {
  appFormInputProperties,
  useAppFormInput,
} from "../composables/form-input.hook";

const properties = defineProps({
  ...appFormInputProperties,
  modelValue: { type: [String, Array], default: undefined },
  items: { type: Array, default: () => [] },
  itemValue: { type: String, required: true },
  itemTitle: { type: String, required: true },
  multiple: { type: Boolean, default: false },
});

// @ts-expect-error custom signature for templateRef
const wrapper = templateRef<{ $el?: HTMLDivElement } | undefined>("wrapper");

const { value, fieldBinding } = useAppFormInput(properties);
</script>
